import { Tabs, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import MyCoupon from "components/coupon/my-coupon";
import RegistCoupon from "components/coupon/regist-coupon";
import EventList from "components/event/event-list";
import Announcement from "components/event/announcement";
import { useParams, useHistory } from "react-router-dom";
import OverEventList from "components/event/over-event-list";

export default function EventsList(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [val, setVal] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setVal(newValue);
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: "이벤트", menu: true }));
  }, [init]);

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  return (
    <main id="main" className="container nopad">
      <Tabs
        value={val}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="진행중인 이벤트" />
        <Tab label="당첨자 발표" />
        <Tab label="종료된 이벤트" />
      </Tabs>
      {val == 0 && <EventList />}
      {val == 1 && <Announcement />}
      {val == 2 && <OverEventList />}

    </main>
  );
}
